import { format, parse } from 'date-fns';

import { WEEK_DAY } from '../constants';
import {
  StoreItemViewModel,
  StoreList,
  StoreListItem,
  StoreListViewModel,
} from '../types/store';

const getOpeningHours = (operatingHours: StoreListItem['operatingHours']) => {
  const today = format(new Date(), 'EEEE');
  const todayIndex = WEEK_DAY.indexOf(today);
  const weekDaysInOrder = [
    ...WEEK_DAY.slice(todayIndex),
    ...WEEK_DAY.slice(0, todayIndex),
  ];

  const formatTime = (time: string): string => {
    const parsedTime = parse(time, 'HH:mm:ss', new Date());
    return format(parsedTime, 'h.mmaaa');
  };

  return weekDaysInOrder.map((day, i) => {
    const currentOperatingHour = operatingHours.find(
      (operatingHour) => operatingHour.day === day,
    );
    const dayLabel = i === 0 ? 'Today' : currentOperatingHour.day;
    const timeLabel =
      currentOperatingHour.open && currentOperatingHour.close
        ? `${formatTime(currentOperatingHour.open)} - ${formatTime(
            currentOperatingHour.close,
          )}`
        : 'Closed';
    return {
      day: dayLabel,
      time: timeLabel,
    };
  });
};

export const createItemViewModel = (
  store: StoreListItem,
): StoreItemViewModel => ({
  ...store,
  address: `${store.addressLine1}, ${store.addressLine2}`,
  id: store.id,
  storeAddress: `${store.addressLine1}, ${store.addressLine2}, ${store.suburb}, ${store.city}`,
  storeImage: store.image,
  storeName: store.displayName,
  selected: false,
  openingHours: getOpeningHours(store.operatingHours),
  fullAddressInOneLine: () =>
    [store.addressLine1, store.addressLine2, store.suburb, store.city]
      .filter(Boolean)
      .join(', '),
});

export const createListViewModel = (
  ccStores: StoreList,
): StoreListViewModel => {
  const stores = ccStores.map((ccStore) => createItemViewModel(ccStore));

  return {
    stores,
    findByStoreId: (id: string) => stores.find((s) => s.id === id),
  };
};

export const addressLine1 = (store: StoreItemViewModel) =>
  [store.addressLine1, store.addressLine2].filter(Boolean).join(', ');
export const addressLine2 = (store: StoreItemViewModel) =>
  [store.suburb, store.city].filter(Boolean).join(', ');
